import React, { useContext, useEffect, useRef, useState } from 'react'
import { Badge, Container, Grid, MenuItem, makeStyles } from '@material-ui/core'
import { observer } from 'mobx-react-lite'
import { RootStoreContext } from 'store/rootStore'
import { isCorrectProject, accesses, isMobile } from 'lib/utils'
import BackdropLoader from 'asterX-UIkit/Loaders/BackdropLoader'
import AsterTabs from 'asterX-UIkit/Tabs/AsterTabs'
import AsterTab from 'asterX-UIkit/Tabs/AsterTab'
import { a11yProps, TabPanel } from 'asterX-UIkit/Tabs/TabPanel'
import AdminPanel from './components/AdminPanel'
import UserPanel from './components/UserPanel'
import CreationPanel from './components/CreationPanel'
import { statusList } from 'lib/constants'
import * as division from 'constants/divisions'

import { MISC_API_URL } from 'lib/env'

import axios from 'axios'
import jwtDecode from 'jwt-decode'

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: 8
  }
}))

const Home = observer(() => {
  const { authStore } = useContext(RootStoreContext)
  const _isMounted = useRef(true)
  const classes = useStyles()
  const [isAdmin, setIsAdmin] = useState(false)
  const [isHD, setIsHD] = useState(false)
  const [selectedTab, setSelectedTab] = useState(0)

  const [userMail, setUserMail] = useState(
    jwtDecode(authStore?.user?.token).sub
  )

  const [count, setCount] = useState(null)

  const handleChangeTab = (_, newValue) => {
    setSelectedTab(newValue)
  }

  const handleStatus = id => {
    authStore.setStatus(statusList.find(f => f.id === Number(id)))
  }

  useEffect(() => {
    if (isCorrectProject()) {
      if (accesses(['ADMIN'])) {
        setIsAdmin(true)
        setSelectedTab(3)
        authStore.setDivision(division.ASTERX_DIVISION)
      }

      if (accesses(['ADMIN_HD'])) {
        setIsHD(true)
        setSelectedTab(3)
        authStore.setDivision(division.HELP_DESK_DIVISION)
      }
    }

    handleStatus(statusList[0].id)

    return () => {
      _isMounted.current = false
    }
  }, [])

  const countFetch = async (authStore, userMail) => {
    try {
      const {
        user: { token }
      } = authStore

      const response = await axios.post(
        `${MISC_API_URL}/support/countSupport`,
        { department: 'ShinhanX', adminUsername: userMail },
        { headers: { Authorization: `Bearer ${token}` } }
      )

      setCount(response?.data || {})
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (isAdmin || isHD) {
      countFetch(authStore, userMail)
    }
  }, [selectedTab])

  return (
    <Container className={classes.root} fullWidth style={{ marginTop: 60 }}>
      <BackdropLoader loading={authStore.loading} />
      <Grid
        container
        direction={'row'}
        justify={'flex-start'}
        alignItems={'center'}
        spacing={2}
      >
        <Grid item xs={12} md={12}>
          <Grid container item justify="space-between" xs={20} md={12}>
            <AsterTabs
              value={selectedTab}
              onChange={handleChangeTab}
              variant="scrollable"
              scrollButtons="auto"
            >
              <AsterTab
                label="Создать заявку"
                {...a11yProps(0)}
                style={{ display: !!(isAdmin || isHD) && 'none' }}
              />
              <AsterTab
                label="Незавершенные"
                {...a11yProps(1)}
                style={{ display: !!(isAdmin || isHD) && 'none' }}
              />
              <AsterTab
                label="Завершенные"
                {...a11yProps(2)}
                style={{ display: !!(isAdmin || isHD) && 'none' }}
              />

              <AsterTab
                {...a11yProps(3)}
                label={
                  <span>
                    Новые
                    <Badge
                      color="primary"
                      badgeContent={count?.countNew}
                      style={{
                        marginLeft: 13,
                        marginBottom: 20
                      }}
                      showZero
                    />
                  </span>
                }
                onClick={() => handleStatus(statusList[1].id)}
                style={{ display: !(isAdmin || isHD) && 'none' }}
              />

              <AsterTab
                {...a11yProps(4)}
                label={
                  <span>
                    Мои заявки
                    <Badge
                      color="primary"
                      badgeContent={count?.countMy}
                      style={{
                        marginLeft: 13,
                        marginBottom: 20
                      }}
                      showZero
                    />
                  </span>
                }
                onClick={() => handleStatus(statusList[2].id)}
                style={{ display: !(isAdmin || isHD) && 'none' }}
              />

              <AsterTab
                {...a11yProps(5)}
                label={
                  <span>
                    В работе
                    <Badge
                      color="primary"
                      badgeContent={count?.countWork}
                      style={{
                        marginLeft: 13,
                        marginBottom: 20
                      }}
                      showZero
                    />
                  </span>
                }
                onClick={() => handleStatus(statusList[2].id)}
                style={{ display: !(isAdmin || isHD) && 'none' }}
              />

              <AsterTab
                {...a11yProps(6)}
                label={statusList[0].label}
                onClick={() => handleStatus(statusList[0].id)}
                style={{ display: !(isAdmin || isHD) && 'none' }}
              />
            </AsterTabs>
          </Grid>

          <TabPanel value={selectedTab} index={0}>
            <CreationPanel />
          </TabPanel>

          <TabPanel value={selectedTab} index={1}>
            {isAdmin || isHD ? (
              <AdminPanel
                selectedTab={selectedTab}
                countFetch={() => countFetch(authStore, userMail)}
              />
            ) : (
              <UserPanel selectedTab={selectedTab} statusList={statusList} />
            )}
          </TabPanel>

          <TabPanel value={selectedTab} index={2}>
            {isAdmin || isHD ? (
              <AdminPanel
                selectedTab={selectedTab}
                countFetch={() => countFetch(authStore, userMail)}
              />
            ) : (
              <UserPanel selectedTab={selectedTab} statusList={statusList} />
            )}
          </TabPanel>

          {[3, 4, 5, 6, 7, 8, 9].map(i => (
            <TabPanel value={selectedTab} index={i}>
              <AdminPanel
                selectedTab={selectedTab}
                countFetch={() => countFetch(authStore, userMail)}
              />
            </TabPanel>
          ))}
        </Grid>
      </Grid>
    </Container>
  )
})

export default Home
